/*
 * Author: tom
 * Time: 2024/09/19
 * 权限配置 以及 路由页面mate.save未保存数据判定
 */
import {
  mapState
} from 'vuex'
export default {
  data() {
    return {
      isActivated: false,
      isChangeData: false, //是否更改数据
      $CurPrefix: this.$CurPrefix,
      $CurSuffix: this.$CurSuffix,
      $currencyUnit: this.$currencyUnit,
    }
  },
  beforeRouteLeave(to, form, next) {
    if (this.isChangeData && form.meta.save) {
      this.$confirm(this.$ts('数据未保存，确认离开该页面?'), this.$ts('提示'), {
        type: 'warning'
      }).then(() => {
        this.isChangeData = false;
        this.$store.dispatch('tagsView/delView', this.$route)
        next(true)
      }).catch(() => {
        next(false)
      })
    } else {
      next(true)
    }
  },
  computed: {
    ...mapState(['platPrivilege', 'isPrivilege']),
  },
  methods: {
    // 设置isChangeData数据
    setChangeData(val = true) {
      this.isChangeData = val;
    },
    getPrivilege(privilege) {
      return this.isPrivilege || !this.platPrivilege.includes(privilege)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/mixin/index.js